
import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import DataTable from "datatables.net-react";
import DT from "datatables.net-dt";
import NiceModal from "@ebay/nice-modal-react";
import Swal from "sweetalert2";
import {
  dateTimeFormatter,
  getLocalDateFromString,
} from "../../utils/utils";

DataTable.use(DT);

const DataSetsTable = ({ documentSets = [], onUpdated = () => { } }) => {
  const activeUser = useSelector((state) => state.users.activeUser);
  const tableRef = useRef(null);
  const [localDataSets, setLocalDataSets] = useState(documentSets);

  const navigate = useNavigate();

  useEffect(() => {
    console.log("!!! USE EFFECT 3: ", documentSets);
    setLocalDataSets(documentSets);
  }, [documentSets]);

  useEffect(() => {
    console.log("!!! USE EFFECT 4");
    const interval = setInterval(() => {
      if (tableRef.current) {
        clearInterval(interval);
      } else {
        console.log("!!! TABLE REF IS NULL");
      }
    }, 10);
  }, []);

  window.formatDate = (date) => {
    const inputDate = new Date(date);

    const pad = (n) => n.toString().padStart(2, "0");

    const formattedDate =
      `${pad(inputDate.getDate())}-${pad(
        inputDate.getMonth() + 1
      )}-${inputDate.getFullYear()} ` +
      `${pad(inputDate.getHours())}:${pad(inputDate.getMinutes())}:${pad(
        inputDate.getSeconds()
      )} ` +
      `GMT${inputDate.toTimeString().slice(9, 14)} (${inputDate
        .toTimeString()
        .match(/\(([^)]+)\)/)[1]
        .split(" ")
        .map((w) => w[0])
        .join("")})`;
    return formattedDate;
  };

  window.edit = (public_id) => {
    window.location.href = `/document-set/${public_id}`;
    return;
  };

  window.delete = (public_id) => {
    console.log("!!! documentset DELETE: ", public_id);
    if (tableRef.current) {
      const table = tableRef.current.dt();
      const row = table.row((idx, data) => data[0] === public_id);

      if (row) {
        const data = row.data();
        Swal.fire({
          title: "Are you sure?",
          text: `You are trying to delete ${data[1]}. You won't be able to revert this!`,
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Yes, delete the documentset!",
        }).then(async (result) => {
          if (result.value) {
            /*setDeleting(true);
            const response = await deleteDocumentSet(public_id);
            console.log("!!! DELETE RESPONSE: ", response);
            const newLocalDataSets = [...localDataSets].filter(
              (documentset) => documentset.public_id !== public_id
            );

            onUpdated(newLocalDataSets);

            setDeleting(false);
            Swal.fire("Deleted!", "The documentset has been deleted.", "success");
              */
          }
        });
      }
    }
  };

  window.email = (public_id) => {
    NiceModal.show("email-documentset", {
      public_id: public_id,
      dt: tableRef.current ? tableRef.current.dt() : null,
    });
  };

  window.showDocumentSetDetails = (public_id) => {
    if (activeUser?.user_type.match(/client/)) {
      navigate(`/client/live-event/${public_id}#presenter`);
    } else {
      navigate(`/live-event/${public_id}#presenter`);
    }
  };

  window.moderateDocumentSetDetails = (public_id) => {
    if (activeUser?.user_type.match(/client/)) {
      navigate(`/client/live-event/${public_id}#moderator`);
    } else {
      navigate(`/live-event/${public_id}#moderator`);
    }
  };

  const tableData = localDataSets.map((documentset) => {
    return [
      documentset.id,
      documentset.public_id,
      `<div><div onclick="
document.querySelector('#copied-${documentset.public_id}').style.display='block';
navigator.clipboard.writeText('https://www.streamy.ai/e/${documentset.public_id}');">https://www.streamy.ai/e/${documentset.public_id}</div><div style="display: none; font-weight: bold;" id="copied-${documentset.public_id}">Copied!</div></div>`,
      documentset.title,
      documentset.description,
      documentset.open_date
        ? dateTimeFormatter.format(getLocalDateFromString(documentset.open_date))
        : "",
      documentset.start_date
        ? dateTimeFormatter.format(getLocalDateFromString(documentset.start_date))
        : "",
      documentset.status,
      documentset?.participant_count ?? 0,
      `<div style="display: flex; flex-direction: row; width: 140px; flex-wrap: wrap;"><div style="display: flex; flex-direction: row;"><button style="width: 40px; display: flex; flex-direction: column; align-items: center; justify-content: center; font-size: 20px; color: black;" title="presenter" onClick="window.showDocumentSetDetails('${documentset.public_id}')" class="bg-orange-400 text-white active:bg-orange-600 font-bold uppercase text-sm px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150" type="button">▶</button></div><div style="display: flex; flex-direction: row;"><button title="moderator" style="width: 40px; display: flex; flex-direction: column; align-items: center; justify-content: center; font-size: 20px; color: black;" onClick="window.moderateDocumentSetDetails('${documentset.public_id}')" class="bg-purple-400 text-white active:bg-purple-600 font-bold uppercase text-sm px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150" type="button">👁</button></div><div style="display: flex; flex-direction: row;"><button title="edit" style="width: 40px; display: flex; flex-direction: column; align-items: center; justify-content: center; font-size: 20px; color: black;" onClick="window.edit('${documentset.public_id}')" class="bg-emerald-400 text-white active:bg-emerald-600 font-bold uppercase text-sm px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150" type="button">✎</button></div><div style="display: flex; flex-direction: row;"><button title="delete" style="width: 40px; display: flex; flex-direction: column; align-items: center; justify-content: center; font-size: 16px; color: black;" onClick="window.delete('${documentset.public_id}')" class="bg-red-400 text-white active:bg-red-600 font-bold uppercase text-sm px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150" type="button">X</button></div>`,
    ];
  });

  return (
    <div className="datasettable">
      <DataTable
        ref={tableRef}
        data={tableData}
        className="display"
        options={{
          responsive: true,
          select: true,
          pageLength: 100,
          order: [[0, "desc"]],
          lengthChange: false,
          searching: false,
        }}
      >
        <thead style={{ color: "var(--main-font-color)", backgroundColor: "var(--content-item-bg)" }}>
          <tr>
            <th>ID</th>
            <th>Public ID</th>
            <th>Link</th>
            <th>Title</th>
            <th>Description</th>
            <th>Opening Time</th>
            <th>Starting Time</th>
            <th>Status</th>
            <th>Users</th>
            <th>Actions</th>
          </tr>
        </thead>
      </DataTable>
    </div>
  );
};

export default DataSetsTable;
